import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { ArrowLeft } from "lucide-react";

/**
 * Shared layout for /privacy and /terms. Single column, museum-quiet,
 * generous reading width on desktop. Sections rendered from a simple
 * array so the content is editable by anyone without touching markup.
 */
export function LegalLayout({ title, subtitle, lastUpdated, sections, testid }) {
    return (
        <div className="relative min-h-screen w-full aurora-wash" data-testid={testid}>
            <Helmet>
                <title>{`${title} — MoodCard`}</title>
                <meta name="robots" content="index,follow" />
                <meta name="description" content={subtitle} />
            </Helmet>

            <div className="absolute inset-0 grain pointer-events-none" />

            {/* Top bar */}
            <header className="sticky top-0 z-10 max-w-3xl mx-auto px-5 pt-5 pb-3 backdrop-blur-md"
                style={{ backgroundColor: "color-mix(in srgb, var(--surface-1) 78%, transparent)" }}
            >
                <Link
                    to="/"
                    data-testid={`${testid}-back`}
                    className="btn-press inline-flex items-center gap-2 font-sans text-[10px] uppercase tracking-[0.32em] text-app-3 hover:text-app transition-colors"
                >
                    <ArrowLeft className="w-3.5 h-3.5" strokeWidth={1.5} />
                    back
                </Link>
            </header>

            <main className="relative z-10 max-w-2xl mx-auto px-6 pt-6 pb-24">
                <p className="font-sans text-[10px] uppercase tracking-[0.4em] text-app-3 mb-3">
                    {subtitle}
                </p>
                <h1 className="font-serif text-app text-3xl sm:text-4xl mb-2" data-testid={`${testid}-title`}>
                    {title}
                </h1>
                <p className="font-sans text-[10px] uppercase tracking-[0.3em] text-app-3 mb-12">
                    last updated · {lastUpdated}
                </p>

                <div className="space-y-9">
                    {sections.map((s, i) => (
                        <section key={s.heading} data-testid={`${testid}-section-${i}`}>
                            <h2 className="font-sans text-[11px] uppercase tracking-[0.35em] text-app mb-3">
                                {s.heading}
                            </h2>
                            {s.body.map((p, j) => (
                                <p key={j} className="font-serif text-app-2 text-[15px] leading-relaxed mb-3">
                                    {p}
                                </p>
                            ))}
                        </section>
                    ))}
                </div>

                <footer className="mt-16 pt-10 border-t border-app/15 text-center">
                    <p className="font-sans text-[9px] uppercase tracking-[0.32em] text-app-3 opacity-65">
                        moodcard · a product of <span className="text-app-2">zephiron group llc</span> · wyoming, usa
                    </p>
                    <p className="mt-2 font-sans text-[9px] uppercase tracking-[0.28em] text-app-3 opacity-50">
                        contact · hello@moodcard.app
                    </p>
                </footer>
            </main>
        </div>
    );
}

export default LegalLayout;
